export const GET_COVERS = 'covers/GET_COVERS'
export const GET_COVERS_SUCCESSFUL = 'covers/GET_COVERS_SUCCESSFUL'
export const GET_COVERS_FAILURE = 'covers/GET_COVERS_FAILURE'

export const UPLOAD_COVERS = 'covers/UPLOAD_COVERS'
export const UPLOAD_COVERS_SUCCESSFUL = 'covers/UPLOAD_COVERS_SUCCESSFUL'
export const UPLOAD_COVERS_FAILURE = 'covers/UPLOAD_COVERS_FAILURE'
